module.exports = __webpack_public_path__ + "static/key-niche-5253a70203a2716e7d3b9f4fc1067c66.webp";